var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container nav-acc-header pad-yellow-background bottom-margin"},[_c('button',{staticClass:"toggleVegButton",on:{"click":_vm.toggleVegetarian}},[(_vm.$store.state.vegetarian === true)?_c('span'):_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }